// 样式引入顺序会影响样式级联：组件库样式 -> @sx/ui 基础与主题 -> 应用变量覆盖
import '@sx/ui/styles/index.scss'
import '@sx/ui/styles/tailwind.css'
import '@/style/index.scss'

import VxeUIPluginRenderElement from '@vxe-ui/plugin-render-element'
import { ElInput, ElOption, ElSelect } from 'element-plus'
import { createApp } from 'vue'
import VxePCUI from 'vxe-pc-ui'
import VXETable from 'vxe-table'

import VTooltip from '@/directive/v-tooltip'
import router from '@/router'
import '@/utils/dayjs'

import App from './App.vue'

VxePCUI.use(VxeUIPluginRenderElement)

const app = createApp(App).use(router).use(VxePCUI).use(VXETable)
app.component('ElInput', ElInput)
app.component('ElSelect', ElSelect)
app.component('ElOption', ElOption)

app.directive('Tooltip', VTooltip)
app.mount('#app')
